import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { PlansComponent } from "../../components/plans/plans.component";
import { AuthService } from "../../services/auth/auth.service";

@Component({
  selector: 'app-subscribe',
  imports: [PlansComponent],
  standalone: true,
  templateUrl: './subscribe.component.html',
  styleUrl: './subscribe.component.scss',
})
export class SubscribePageComponent {
  auth = inject(AuthService);
  router = inject(Router);

  pricingUrl = `${environment.WEBSITE}/pricing`;

  get isSubscribed(): boolean {
    return this.auth.subscribed;
  }

  get isTrialEligible(): boolean {
    const user = (this.auth as any)._$user?.value;
    return user?.is_trial_eligible ?? true;
  }

  navigateBack() {
    if (this.isSubscribed) {
      this.router.navigate(['/dashboard']);
    } else {
      this.auth.signout();
    }
  }
}
